import { Box, Typography } from '@mui/material'
import React from 'react'
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";


export default function ViewAllBlueButton({onClick, buttonTitle, showEndIcon}) {
  return (
   <>
      <Box
                             sx={{
                               background: "#FBF5FB",
                               cursor: "pointer",
                               borderRadius: "6px",
                               padding: "10px",
                               paddingX: "20px",
                               display: "flex",
                               gap: 1,
                               alignItems: "center",
                             }}
                          onClick={onClick}
                           >
                             <Typography
                               fontFamily="Inter"
                               fontWeight={600}
                               color="#572575"
                               fontSize="14px"
                             >
                              {buttonTitle ? buttonTitle : "View All"} 
                             </Typography>
                             {showEndIcon && ( 
                             <ArrowForwardIosIcon
                               fontSize="small"
                               style={{
                                 color: "#572575",
                                 fontSize: "0.8rem",
                                 fontWeight: 700,
                               }}
                             />

                             )}
                           </Box>
   </>
  )
}
